import { render } from "./CountDown.vue?vue&type=template&id=4afe1e0b"
import script from "./CountDown.vue?vue&type=script&lang=js"
export * from "./CountDown.vue?vue&type=script&lang=js"

import "./CountDown.vue?vue&type=style&index=0&id=4afe1e0b&lang=scss"

import exportComponent from "/Users/robo1/Documents/Admin/campanha-pedido/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__